import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: any) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 800,
      padding: "20px",
      justifyContent: 'center',
      alignItems: 'stretch'
    },
    title: {
      textAlign: 'center',
      marginBottom: '70px',
      font: `700 19px/25px "Montserrat"`,
      color: theme.custom.colors.primary,
    },
    customTextArea: {
      '&>label': {
        font: 'normal normal 400 16px/16px Montserrat',
        color: theme.custom.colors.primary,
        marginBottom: 4,
        '&:first-letter': {
          textTransform: 'uppercase'
        }
      }
    },
    inputName: {
      marginBottom: 28,
      '&>div:first-child>label': {
        font: 'normal normal 400 16px/16px Montserrat',
        color: theme.custom.colors.primary,
        marginBottom: 4,
        '&:first-letter': {
          textTransform: 'uppercase'
        }
      }
    },
    customUploadImage: {
      '& div:first-child>label': {
        font: 'normal normal 400 16px/16px Montserrat',
        color: theme.custom.colors.primary,
      },
      '& div:nth-child(2)': {
        marginTop: 8,
        marginBottom: 28,
        width: 181,
        height: 124,
        '& label': {
          font: 'normal normal 400 14px/18px Montserrat',
          color: theme.custom.colors.placeholder,
          width: 125,
          textAlign: 'center'
        },
        '& img': {
          width: '100%',
          height: '100%'
        }
      }
    },
    submitButton: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: "20px",
      '& button': {
        height: 32,
        width: 160,
        background: theme.custom.colors.purple,
        fontWeight: 'bold',
        color: theme.custom.colors.white,
        fontSize: theme.custom.fontSize.size16,
        fontFamily: theme.custom.fontFamily.title,
        boxShadow: 'none',
        textTransform: 'inherit',
        borderRadius: '30px',
        '& img': {
          marginLeft: 8,
        },
        '&:hover': {
          background: theme.custom.colors.purple,
        },
      },
    },
    uploadContainer: {
      display: "flex", 
      flexDirection: "column", 
      justifyContent: "center",
      paddingLeft: "10px",
      paddingRight: "10px",
    }, 
    iconLoading: {
      marginLeft: '15px',
      '& svg': {
        color: '#fff',
      },
    },
    uploadImageTxt: {
      font: theme.custom.font.paragraph3,
    },
    selectAppIcon: {
      display: "flex",
      justifyContent: "center",
    },
    uploadTxtHeader: {
      marginBottom: 10,
      font: theme.custom.font.montserrat14Bold,
      textAlign: 'center'
    },
    uploadText: {
      font: theme.custom.font.paragraph2,
      textAlign: 'center'
    },
    uploadImage: {
      marginTop: '20px',
      border: '2px dashed #D2D2D2',
      borderRadius: '10px',
      padding: "10px",
      backgroundColor: '#FDFDFD',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      position: 'relative',
      '& input[type="file"]': {
        fontSize: 0,
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
        opacity: 0,
        cursor: 'pointer',
        width: '100%',
      },
    },
  };
});

export default useStyles;
